/* src/app/features/empresas-bloqueadas/envio-consulta-protocolo-empresa/envio-consulta-protocolo-empresa-listagem.component.scss */
/*# sourceMappingURL=envio-consulta-protocolo-empresa-listagem.component.css.map */
